/**
 * Cukai jualan (SST) dikira daripada data, bukan dikodkan.
 *
 * Peraturan (ADR-0005 §6):
 * - Kadar disimpan dalam *basis points* integer: 5% → `500`, 6% → `600`. Tiada perpuluhan.
 * - Kadar boleh termasuk dalam harga (`taxInclusive`) atau ditambah di atasnya.
 * - Harga termasuk cukai: cukai = jumlah × kadar / (10000 + kadar), dibundar half-up.
 */
import { assertSen, divRoundHalfUp } from './money.js';
export const BP_SCALE = 10_000;
export function assertRateBp(rateBp, label = 'kadar cukai') {
    if (!Number.isInteger(rateBp)) {
        throw new TypeError(`${label} mesti integer basis points, diterima ${rateBp}`);
    }
    if (rateBp < 0 || rateBp > BP_SCALE) {
        throw new RangeError(`${label} mesti antara 0 dan ${BP_SCALE}, diterima ${rateBp}`);
    }
}
/** Cukai ke atas asas yang belum termasuk cukai. */
export function taxFromNet(netSen, rateBp) {
    assertSen(netSen, 'asas cukai');
    assertRateBp(rateBp);
    return divRoundHalfUp(netSen * rateBp, BP_SCALE);
}
/** Cukai yang terkandung dalam jumlah yang sudah termasuk cukai. */
export function taxFromGross(grossSen, rateBp) {
    assertSen(grossSen, 'jumlah termasuk cukai');
    assertRateBp(rateBp);
    return divRoundHalfUp(grossSen * rateBp, BP_SCALE + rateBp);
}
/** Bahagian bersih (tanpa cukai) daripada jumlah yang termasuk cukai. */
export function netFromGross(grossSen, rateBp) {
    assertSen(grossSen, 'jumlah termasuk cukai');
    assertRateBp(rateBp);
    return grossSen - taxFromGross(grossSen, rateBp);
}
//# sourceMappingURL=tax.js.map